import React from "react";
import "./style.css";

const SlideSwitch = props => (
  <div style={props.style ? props.style : {}}>
    <label className="switch">
      <input type="checkbox" checked={props.checked} onClick={props.onClick} />
      <span className="slider round" />
    </label>
  </div>
);

export default SlideSwitch;
